<template>
	<div class="allocation-expert">
		<table id="ktfz-datatable" class="table table-hover table-bordered table-centered table-proApp">
			<thead>
				<tr>
					<th class="text-center">评审组名称</th>
					<th class="text-center">待评数量</th>
					<th class="text-center">评审组长</th>
					<th class="text-center">评审组其他成员</th>
					<th class="text-center">操作</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="(item, index) in groupList" :key="index">
					<td class="text-center">{{ item.name }}</td>
					<td class="text-center">{{ item.declareId | getTopicNum }}</td>
					<td class="text-center">{{ item.groupLeaderName }}</td>
					<td class="text-center">{{ item.groupMembersName }} <span @click="handleClose(item)" v-if="item.groupMembersName" class="close_btn">清空</span></td>
					<td class="text-center">
						<button type="button" class="btn btn-primary btn-rounded ml-1 mr-1" data-toggle="modal" data-target="#setLeader" @click="openExpertListDialog('sigle', index)"  v-if="reviewState==2">
							设置评审组长
						</button>
						<button type="button" class="btn btn-primary btn-rounded ml-1 mr-1" data-toggle="modal" data-target="#setMembers" @click="openExpertListDialog('multiple', index)"  v-if="reviewState==2">
							设置成员
						</button>
						<!-- <button type="button" class="btn btn-danger btn-rounded ml-1 mr-1" data-toggle="modal" data-target="#setMembers" @click="openExpertListDialog('multiple', index)"  v-if="reviewState==2">
							清空评审组长
						</button>
						<button type="button" class="btn btn-danger btn-rounded ml-1 mr-1" data-toggle="modal" data-target="#setMembers" @click="openExpertListDialog('multiple', index)"  v-if="reviewState==2">
							清空成员
						</button> -->
					</td>
				</tr>
			</tbody>
		</table>

		<div class="text-center">
			<!-- <button type="button" class="btn btn-info">上一步</button> -->
			<button type="button" class="btn btn-info" v-if="reviewState==2" @click="save">保存并下一步</button>
		</div>

		<el-dialog :title="expertDialogTitle" :visible.sync="expertListdialogVisible" width="70%" :close-on-click-modal="false">
			<div class="tip">说明：评审专家由“系统管理员”在“系统管理——用户角色授权”中的评审专家库中指定的</div>
			<el-form :inline="true" ref="expertListFormRef" :model="expertListForm" label-width="80px">
				<el-form-item label="姓名"><el-input v-model="expertListForm.name"></el-input></el-form-item>
				<!-- <el-form-item label="研究专长"><el-input v-model="expertListForm.name"></el-input></el-form-item> -->
				<el-form-item label="职称">
					<el-select v-model="expertListForm.rank" clearable placeholder="请选择">
						<el-option v-for="item in jobTitleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item><el-button type="primary" @click="handleSearch">查询</el-button></el-form-item>
			</el-form>
			<!-- <el-table
				border
				ref="expertListRef"
				:data="expertList"
				highlight-current-row
				@current-change="expertSigleSelect"
				@selection-change="expertMultipleSelect"
				style="width: 100%"
			> -->
			<el-table
				border
				ref="expertListRef"
				:data="expertList"
				highlight-current-row
				@selection-change="expertMultipleSelect"
				style="width: 100%"
			>
				<!-- <el-table-column v-if="expertDialogTitle === '请选择组员'" type="selection" width="55"></el-table-column> -->
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column property="realName" label="姓名" width="120"></el-table-column>
				<el-table-column property="sex" label="性别" width="120">
					<template slot-scope="scope">
						{{ scope.row.sex == 1 ? '男' : '女' }}
					</template>
				</el-table-column>
				<el-table-column property="unitName" label="单位"></el-table-column>
				<!-- <el-table-column property="Thefeat" label="研究专长"></el-table-column> -->
				<el-table-column property="rank" label="职称">
					<template slot-scope="scope">
						{{ scope.row.rank | getRankName }}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				style="text-align: center;margin-top: 20px;"
				@size-change="expertSizeChange"
				@current-change="expertCurrentChange"
				:current-page="expertListForm.pageNumber"
				:page-sizes="[10, 50]"
				:page-size="expertListForm.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="expertTotal"
			></el-pagination>

			<span slot="footer" class="dialog-footer">
				<el-button @click="expertListdialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addReviewPerson">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getGroupListByReviewId, allocationExpert, getReviewBaseInfoById } from '@/api/after/expertReviewSettings.js';
import { getPlatformInformationData, getListByRoleId } from '@/api/after/systemManagement.js';
let that;
export default {
	data() {
		return {
			//分组列表
			groupList: [],
			expertListdialogVisible: false,
			expertDialogTitle: '请选择评审组长',
			// 专家筛选参数
			expertListForm: {
				pageNumber: 1,
				pageSize: 10,
				roleId: 3, //roleId为3时为专家
				name: '',
				rank: '',
				notIds:[]
			},
			// 专家列表
			expertList: [],
			expertTotal: 0,
			// 职称列表
			jobTitleOptions: [],
			// 当前编辑分组
			curGroupIndex: 0,
			// 单选
			SigleSelectVal: {},
			// 多选
			MultipleSelectVal: [],
			reviewState: 0,
			
		};
	},
	filters: {
		// 获取课题数
		getTopicNum(val) {
			if (val) {
				return val.split(',').length;
			} else {
				return 0;
			}
		},
		// 获取职称名字
		getRankName(val) {
			if (val&&val!=='0') {
				let obj = that.jobTitleOptions.find(item => {
					return item.id == val;
				});
				return obj.name;
			}else{
				return '无职称'
			}
		},
		getMemberName(val) {
			if (val) {
				return val.join('、');
			} else {
				return '';
			}
			// if (val&&val.length>0) {
			// 	let nameArr = []
			// 	val.forEach(item=>{
			// 		nameArr.push(`${item.realName}(${item.username})`)
			// 	})
			// 	return nameArr.join('、')
			// }else{
			// 	return ''
			// }
		}
	},
	beforeCreate() {
		that = this;
	},
	created() {
		this.getReviewBaseInfoById();
		// 获取已经添加的分组
		this.getGroupListByReviewId(this.$route.query.reviewId);
		// 获取职称列表
		this.getJobTitleList();
	},
	methods: {
		// 根据评审ID获取评审基本信息
		async getReviewBaseInfoById() {
			const res = await getReviewBaseInfoById(this.$route.query.reviewId);
			if (res.code == 200) {
				console.log('获取当前评审状态',res);
				this.reviewState = res.data.reviewState;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取分组列表
		async getGroupListByReviewId(id) {
			const res = await getGroupListByReviewId(id);
			if (res.code == 200) {
				console.log('课题分组123', res);
				this.groupList = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取职称
		async getJobTitleList() {
			const res = await getPlatformInformationData(7);
			if (res.code == 200) {
				this.jobTitleOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		handleClose(item){
			console.log(item);
			this.groupList[this.curGroupIndex].groupMembersId = '';
			this.groupList[this.curGroupIndex].groupMembersName ='';
		},
		// 查询专家
		handleSearch(){
			this.expertListForm.pageNumber=1;
			this.getListByRoleId();
		},
		// 打开专家对话框
		openExpertListDialog(type, index) {
			this.curGroupIndex = index;
			if (type == 'sigle') {
				this.expertDialogTitle = '请选择评审组长';
				this.expertListdialogVisible = true;
			} else if (type == 'multiple') {
				this.expertDialogTitle = '请选择组员';
				this.expertListdialogVisible = true;
			}
			this.expertListForm.notIds = this.filterCheckedExpert()
			this.expertListForm.pageNumber=1;
			this.expertListForm.pageSize=10;
			this.getListByRoleId();
		},
		// 专家选择
		expertSigleSelect(val) {
			this.SigleSelectVal = val;
			console.log(val);
		},
		// 专家多选
		expertMultipleSelect(val) {
			console.log('专家多选', val);
			this.MultipleSelectVal = val;
		},
		// 获取专家列表
		async getListByRoleId() {
			const res = await getListByRoleId(this.expertListForm);
			if (res.code == 200) {
				console.log('获取专家列表---',res);
				this.expertList = res.data.records;
				this.expertTotal = res.data.total;
			}
		},
		// 添加评审长或者评审成员
		addReviewPerson() {
			if (this.MultipleSelectVal.length === 0) {
				this.$message.error('请选择至少选择一个用户！')
				return
			}
			if (this.expertDialogTitle === '请选择评审组长') {
				console.log(this.SigleSelectVal, this.groupList);
				if (this.MultipleSelectVal.length > 1) {
					this.$message.error('评审组长只能单选！')
					return 
				}
				let reviewGroupLeader = this.MultipleSelectVal[0]
				this.groupList[this.curGroupIndex].groupLeaderId = reviewGroupLeader.id;
				this.groupList[this.curGroupIndex].groupLeaderName = `${reviewGroupLeader.realName}(${reviewGroupLeader.username})`;
				// this.groupList[this.curGroupIndex].groupLeaderObj = reviewGroupLeader
				// this.MultipleSelectVal = [];
			} else if (this.expertDialogTitle === '请选择组员') {
				console.log(this.MultipleSelectVal, this.groupList);
				let idArr = [];
				let nameArr = [];
				this.MultipleSelectVal.forEach(item => {
					idArr.push(item.id);
					nameArr.push(`${item.realName}(${item.username})`);
				});
				let oldIdArr=this.groupList[this.curGroupIndex].groupMembersId ?this.groupList[this.curGroupIndex].groupMembersId.split(","):[]
				let oldNameArr=this.groupList[this.curGroupIndex].groupMembersName ?this.groupList[this.curGroupIndex].groupMembersName.split(","):[]
				idArr=idArr.concat(oldIdArr)
				nameArr=nameArr.concat(oldNameArr)
				console.log(oldIdArr,oldNameArr,idArr,nameArr);
				this.groupList[this.curGroupIndex].groupMembersId = idArr.join(',');
				this.groupList[this.curGroupIndex].groupMembersName = nameArr.join(',');
				// this.groupList[this.curGroupIndex].groupMembersArr = this.MultipleSelectVal
				this.MultipleSelectVal = [];
			}
			this.expertListdialogVisible = false;
			console.log('123154',this.groupList);
		},
		// 保存这一步
		async save() {
			let data = JSON.parse(JSON.stringify(this.groupList));
			const res = await allocationExpert(data);
			if (res.code == 200) {
				this.$message({
					type: 'success',
					message: '保存成功',
					duration: 1500,
					onClose: () => {
						this.$emit('finish');
					}
				});
			} else {
				this.$message.error(res.data);
			}
		},
		// 过滤已选择的专家
		filterCheckedExpert(){
			let expertArr = []
			this.groupList.forEach((item,index)=>{
				if (item.groupLeaderId) {
					expertArr.push(item.groupLeaderId)
				}
				if (item.groupMembersId) {
					expertArr = expertArr.concat(item.groupMembersId.split(','))
				}
			})
			return expertArr
		},
		expertSizeChange(val) {
			this.expertListForm.pageSize = val;
			this.getListByRoleId()
		},
		expertCurrentChange(val) {
			this.expertListForm.pageNumber = val;
			this.getListByRoleId()
		}
	}
};
</script>

<style scoped lang="scss">
	.tip{
		margin-bottom: 20px;
	}
	.close_btn{
		cursor: pointer;
		margin-left: 10px;
		color: rgb(241, 98, 98) !important;
	}
</style>
